import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import { GlobalFooterContext } from '../../context/GlobalFooterContext.js';
import { titleMessages } from '../../messages.js';
import { messages } from '../../shared/messages/navigation.js';
import { devPlatformUrl, baseURL, stakingUrl, onrampUrl, embWalletsUrl, walletlinkUrl, coinbaseAppUrl, exchangeApiUrl, primeApiUrl, baseNodeUrl, onchainKitUrl } from '../../shared/utils/links.js';
import CDSFooterLink from '../CDSFooterLink.js';
import FooterColumn from './FooterColumn.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function DevelopersColumn() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalFooterContext),
    isUserFromCountry = _useContext.isUserFromCountry;
  const isUKUser = isUserFromCountry('GB');
  return /*#__PURE__*/jsxs(FooterColumn, {
    heading: formatMessage(messages.developers),
    children: [/*#__PURE__*/jsx(CDSFooterLink, {
      href: devPlatformUrl,
      children: formatMessage(titleMessages.devPlatform)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: baseURL,
      children: formatMessage(titleMessages.base)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: stakingUrl,
      children: formatMessage(titleMessages.stakingFooterLink)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: onrampUrl,
      children: formatMessage(titleMessages.onrampFooterLink)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: embWalletsUrl,
      children: formatMessage(titleMessages.embWallets)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: walletlinkUrl,
      children: formatMessage(titleMessages.walletSdk)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: coinbaseAppUrl,
      children: formatMessage(titleMessages.coinbaseApp)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: exchangeApiUrl,
      children: formatMessage(titleMessages.exchangeApi)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: primeApiUrl,
      children: formatMessage(titleMessages.primeApi)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: baseNodeUrl,
      children: formatMessage(titleMessages.baseNode)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: onchainKitUrl,
      children: formatMessage(titleMessages.buildOnchainApps)
    })]
  });
}
const DevelopersColumn$1 = /*#__PURE__*/memo(DevelopersColumn);
export { DevelopersColumn$1 as default };
//# sourceMappingURL=DevelopersColumn.js.map
